export const replaceSearchFieldDummyId = 50000;

export enum ReplaceDomainNodeType {
  Default = 'Default',
  Dummy = 'Dummy'
}

export enum MapFilterType {
  DomainNode = 'domainNode',
  ReplaceDomainNode = 'replaceDomainNode'
}
